export default "__VITE_ASSET__DDDfPayA__"